import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Applause from '../views/Applause.vue'
import LoginPage from '../views/LoginPage.vue'
import Admin from '../views/Admin.vue'


import { store } from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    meta: { title: 'Login' },
    component: LoginPage,
  },
  {
    path: '/',
    name: 'Home',
    meta: { title: 'Applause' },
    component: Home
  },
  {
    path: '/admin',
    name: 'Admin',
    meta: { title: 'Admin' },
    component: Admin
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/applause/:eventId',
    name: 'Applause',
    meta: { title: 'Applause' },
    component: Applause
  },
  {
    // catch all 404 - define at the very end
    path: "*",
    component: () => import("../views/NotFound.vue")
    }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['Login', 'Applause', 'Home', 'About'];
  const authRequired = !publicPages.includes(to.name)
  //const loggedIn = localStorage.getItem('user');
  const userStatus = store.state.user.status

  if (authRequired && userStatus !== 'loggedIn') {
      let redirectUrl = '/login'
      if (to.path !== '/') {
          redirectUrl += `?next=${to.path}`
      }
      return next(redirectUrl)
  }

  document.title = to.meta.title

  next()
})

export default router
